module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integralMallDetail zdy-groupList"
  }, [_c('x-header', {
    staticClass: "zdyheaderBlue"
  }, [_vm._v("商品详情")]), _vm._v(" "), _c('img', {
    staticClass: "banner",
    attrs: {
      "src": 'https://front.cd.jinxin-fertility.com' + _vm.bannerimg + '?t=' + new Date().getTime()
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', [_vm._v("价格：" + _vm._s(_vm.points) + "积分")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "normal"
    }
  }, [_c('label', [_vm._v("数量：")]), _c('inline-x-number', {
    attrs: {
      "width": "40px",
      "min": 1,
      "max": _vm.inventory
    },
    model: {
      value: (_vm.num),
      callback: function($$v) {
        _vm.num = $$v
      },
      expression: "num"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("库存：" + _vm._s(_vm.inventory))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exchangeInstructions),
      expression: "exchangeInstructions"
    }]
  }, [_c('divider', [_vm._v("兑换领取须知")]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    domProps: {
      "innerHTML": _vm._s(_vm.exchangeInstructions)
    }
  })], 1), _vm._v(" "), _c('x-button', {
    staticClass: "changeBtn",
    class: _vm.title.indexOf('好孕果') != -1 ? 'greenBtn' : 'change',
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        _vm.exchangeClick($event)
      }
    }
  }, [_vm._v("确认兑换")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('confirm', {
    staticClass: "integralMallzdy-dialog",
    attrs: {
      "close-on-confirm": false,
      "title": "收货地址"
    },
    on: {
      "on-confirm": _vm.giveConfirm,
      "on-hide": _vm.giveHide
    },
    model: {
      value: (_vm.confirmshow),
      callback: function($$v) {
        _vm.confirmshow = $$v
      },
      expression: "confirmshow"
    }
  }, [_c('group', {
    attrs: {
      "label-width": "4.5em",
      "label-margin-right": "0.5em",
      "label-align": "right"
    }
  }, [_c('x-textarea', {
    attrs: {
      "title": "收货地址:",
      "placeholder": "请输入",
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "13px",
      "margin-top": "5px"
    }
  }, [_vm._v("说明：请核对邮寄地址，一经提交，不得修改")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d782964","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/integralMallProject/integralMallDetail.vue
// module id = wv15
// module chunks = 6